import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"

const gsapNavigationAnchors = {};

gsapNavigationAnchors.init = () => {
    gsap.registerPlugin(ScrollTrigger);

    let fixedElem = ".js-navigation-anchors-fixed";

    if (document.querySelector(fixedElem)) {

        ScrollTrigger.create({
            trigger: ".product-specifics__wrapper",
            start: "top top",
            end: "bottom bottom",
            pin: fixedElem,
            scrub: 1,
            pinSpacing: false,
            onToggle: () => document.body.classList.toggle('no-navbar-animation'), // prevent navbar visibility when scrolling up
            // markers: true
        });
    }

};

export default gsapNavigationAnchors;
